import { useMemo } from 'react';
import { ItemScheme } from '../../../Components/Form/MagicFormItem';

export function useMagicItemRules(item: ItemScheme) {
	const { maxLength } = useMemo(() => {
		let maxLength = undefined;
		for (const rule of item?.settings?.rules || []) {
			if (rule.type === 'maxLength') {
				maxLength = rule.value;
			}
		}
		return { maxLength };
	}, [item]);

	return { maxLength };
}
